<!--
 * @Author: cryi.liu
 * @Date: 2020-05-08 14:45:48
 * @LastEditTime: 2020-06-13 22:43:37
 * @Description: 大题信息
 -->
<template>
  <div class="big-question">
    <big-question-overview
      :count="bigQuestion.libraryCount"
      :score="bigQuestion.score"
      :part-id="bigQuestion.partId"
      :required="bigQuestion.isRequiredQuestion" />
    <div class="placeholder">
      <p class="title">
        <span>{{ title }}</span>
        <i-button
          size="small"
          @click="clickAddQuestionBtnHandler(bigQuestion)">添加题目</i-button>
      </p>
      <div class="info">
        <p>产品组：{{ productionGroup }}</p>
        <p v-if="productionNames.length > 0">型号：{{ productionNames }}</p>
        <p v-if="questionLibTypes.length > 0">题库类型：{{ questionLibTypes }}</p>
        <p>年份：{{ questionYears }}</p>
        <p>难度：{{ questionLevels }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BigQuestionOverview from './BigQuestionOverview.vue';

export default {
  name: 'CreateBigQuestion',
  components: {
    BigQuestionOverview,
  },
  props: {
    bigQuestion: { type: Object, reuqired: true },
  },
  computed: {
    title() {
      return `${this.bigQuestion.questionType}题`;
    },
    productionGroup() {
      let str = '';

      Object.keys(this.bigQuestion.groupCodeMap).forEach((key) => {
        str += `${key}（${this.bigQuestion.groupCodeMap[key]}）、`;
      });

      str = str.substring(0, str.length - 1);

      return str;
    },
    productionNames() {
      let str = '';

      if (this.bigQuestion.productNameList && this.bigQuestion.productNameList.length > 0) {
        str = this.bigQuestion.productNameList.join('、');

        return str;
      }

      Object.keys(this.bigQuestion.productNameMap).forEach((key) => {
        str += `${key}（${this.bigQuestion.productNameMap[key]}）、`;
      });

      str = str.substring(0, str.length - 1);

      return str;
    },
    questionLibTypes() {
      let str = this.bigQuestion.libraryTypes.join('、');
      const reg = /型号专属/;

      if (reg.test(str)) {
        const subStr = `（${this.bigQuestion.productNames.join('、')}）`;
        const { index } = reg.exec(str);
        str = str.slice(0, index + 4) + subStr + str.slice(index + 4, str.length);
      }

      return str;
    },
    questionYears() {
      return this.bigQuestion.years.join('、');
    },
    questionLevels() {
      return this.bigQuestion.levels.join('、');
    },
  },
  methods: {
    ...mapActions({
      setAddBigQuestionRuleOfQuestionType: 'createPaperStore/invokeSetAddBigQuestionRuleOfQuestionType',
      setAddBigQuestionRuleOfPartId: 'createPaperStore/invokeSetAddBigQuestionRuleOfPartId',
      setAddQuestionByProductGroupModalType: 'createPaperStore/invokeSetAddQuestionByProductGroupModalType',
      setAddQuestionByProductGroupModalShow: 'createPaperStore/invokeSetAddQuestionByProductGroupModalShow',
      setAddQuestionByProductCodeModalType: 'createPaperStore/invokeSetAddQuestionByProductCodeModalType',
    }),
    /**
     * 点击添加题目按钮处理函数
     */
    clickAddQuestionBtnHandler({ questionType, partId }) {
      this.setAddBigQuestionRuleOfQuestionType({ questionType });
      this.setAddBigQuestionRuleOfPartId({ partId });
      this.$emit('click-update-question', 'update');
    },
  },
};
</script>

<style lang="less" scoped>
.big-question {
  width: 100%;
  display: flex;
  justify-content: flex-start;

  > .placeholder {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 32px;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #ddd;

    > .title {
      flex: 0 0 36px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 36px;
      padding: 0 20px;
      border-bottom: 1px solid #ddd;

      > span:first-of-type {
        margin-right: 12px;
      }
    }

    > .info {
      float: 1;
      display: flex;
      flex-direction: column;
      padding: 24px 20px;

      > p {
        margin-bottom: 12px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
